import styled from 'styled-components'

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const Icon = styled.svg`
  fill: none;
  stroke: ${(props) => {
    let color = props.color || props.theme.green
    if (props.isTransparent) {
      color = props.theme.white
    }
    return color
  }};
  stroke-width: 3px;
`

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;

  background: ${(props) => {
    let color = (props.checked && props.bgColor) || props.theme.white
    if (props.disabled) {
      return props.theme.grey
    }
    if (props.isTransparent) {
      color = 'transparent'
    }
    return color
  }};
  border: 1px solid
    ${(props) => {
      let color = props.borderColor || props.theme.fontGrey
      if (props.isTransparent) {
        color = props.theme.white
      }
      return color
    }};
  border-radius: 3px;
  transition: all 150ms;
  margin-right: 10px;
  padding: 1px;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`
